import { getBidVehicles, getWatchListVehicles } from 'apis/dashboardApis'
import { Link, useLocation } from 'react-router-dom'
import { VehicleList } from '../modules/VehicleList'
import { IconSvg } from '@prism/icon'
import { BUY_VEHICLE_NO_ACTIVITY } from 'common/constants'
import { BiddingSidePanel } from 'modules/BiddingSidePanel'
import { AppRoutes } from 'common/routes'
import { useCallback, useContext, useEffect } from 'react'
import { setListingBreadcrumb } from 'utils/breadcrumbUtils'
import { Layout } from '../layouts/Layout'
import { VehicleListContext, VehicleListContextProvider } from 'modules/VehicleList/VehicleListContext'
import { DefaultErrorBoundary } from 'modules/DefaultErrorBoundary'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'
import { GetBidVehiclesRequest } from 'types/vehicleTypes'
import { setCustomClick } from 'utils/analyticsUtils'

export const CurrentBidsPageContent = () => {
  const location = useLocation()
  const { setVehiclesState } = useContext(VehicleListContext)
  const { endPageLoad } = useDtmAnalytics()
  useEffect(() => {
    setListingBreadcrumb('Current Bids', location.pathname)
  }, [])

  const handleGetBidVehicles = useCallback(async (request: GetBidVehiclesRequest) => {
    const response = await getBidVehicles(request)
    if (response?.Items?.length == 0 && response?.TotalRecords > 0) {
      setVehiclesState((state) => {
        state.currentPage = 0
      })
    }
    endPageLoad(response?.Items, { searchData: { sortBy: response.SortBy, sortOptions: response.SortOptions } })
    return response
  }, [])

  return (
    <>
      <Layout title="Current Bids">
        <VehicleList
          title="Current Bids"
          navigationLink={(count) => (
            <Link
              className="navigation-link"
              onClick={() => setCustomClick('Watch List', { usePageName: true })}
              to={AppRoutes.WatchList}
            >
              <span className="right-action">
                <IconSvg glyph="eye" color="primary" />
                &nbsp;Watch List&nbsp;<b>({count})</b>
              </span>
            </Link>
          )}
          wideListImage
          queryFunction={handleGetBidVehicles}
          countQueryFunction={getWatchListVehicles}
          noActivityMessage={BUY_VEHICLE_NO_ACTIVITY.CURRENT_BIDS}
          isShowRemoveBidButton={true}
        ></VehicleList>
        <DefaultErrorBoundary>
          <BiddingSidePanel isDealerShipSelectable={true}></BiddingSidePanel>
        </DefaultErrorBoundary>
      </Layout>
    </>
  )
}

export const CurrentBidsPage = () => {
  return (
    <VehicleListContextProvider>
      <CurrentBidsPageContent />
    </VehicleListContextProvider>
  )
}
